export default {
  methods: {
    $_getTimeDifference(d1, d2) {
      let difference = d1 - d2

      const daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24)
      difference -= daysDifference * 1000 * 60 * 60 * 24

      const hoursDifference = Math.floor(difference / 1000 / 60 / 60)
      difference -= hoursDifference * 1000 * 60 * 60

      const minutesDifference = Math.floor(difference / 1000 / 60)
      difference -= minutesDifference * 1000 * 60

      const secondsDifference = Math.floor(difference / 1000)

      let timeLeftString = ''

      if (daysDifference) {
        if (daysDifference % 10 === 0
          || ((daysDifference % 100) > 10 && (daysDifference % 100) < 20)
          || (daysDifference % 10 === 5 || daysDifference % 10 === 6
            || daysDifference % 10 === 7 || daysDifference % 10 === 8
            || daysDifference % 10 === 9)) {
          timeLeftString += `${daysDifference} дней`
        } else if (daysDifference % 10 === 2 || daysDifference % 10 === 3
          || daysDifference % 10 === 4) {
          timeLeftString += `${daysDifference} дня`
        } else {
          timeLeftString += `${daysDifference} день`
        }
      }

      if (hoursDifference) {
        if (hoursDifference % 10 === 2 || hoursDifference % 10 === 3
          || hoursDifference % 10 === 4) {
          timeLeftString += ` ${hoursDifference} часа`
        } else if (hoursDifference % 10 === 0 || (hoursDifference > 10 && hoursDifference < 20)
          || (hoursDifference % 10 === 5 || hoursDifference % 10 === 6 || hoursDifference % 10 === 7
          || hoursDifference % 10 === 8 || hoursDifference % 10 === 9)) {
          timeLeftString += ` ${hoursDifference} часов`
        } else {
          timeLeftString += ` ${hoursDifference} час`
        }
      }

      if (minutesDifference) {
        if (minutesDifference % 10 === 0
          || (minutesDifference > 10 && minutesDifference < 20)
          || (minutesDifference % 10 === 5 || minutesDifference % 10 === 6
          || minutesDifference % 10 === 7
          || minutesDifference % 10 === 8 || minutesDifference % 10 === 9)) {
          timeLeftString += ` ${minutesDifference} минут`
        } else if (minutesDifference % 10 === 2 || minutesDifference % 10 === 3
          || minutesDifference % 10 === 4) {
          timeLeftString += ` ${minutesDifference} минуты`
        } else {
          timeLeftString += ` ${minutesDifference} минуту`
        }
      }

      if (secondsDifference) {
        if (secondsDifference % 10 === 0
          || (secondsDifference > 10 && secondsDifference < 20)
          || (secondsDifference % 10 === 5 || secondsDifference % 10 === 6
          || secondsDifference % 10 === 7
          || secondsDifference % 10 === 8 || secondsDifference % 10 === 9)) {
          timeLeftString += ` ${secondsDifference} секунд`
        } else if (secondsDifference % 10 === 2 || secondsDifference % 10 === 3
          || secondsDifference % 10 === 4) {
          timeLeftString += ` ${secondsDifference} секунды`
        } else {
          timeLeftString += ` ${secondsDifference} секунда`
        }
      }

      return timeLeftString
    }
  }
}
